import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const ContentCourseSpeechRateSummary = (props) => (
  <KpiSummary
    isLoading={props.isLoading}
    title="Speech recognition difficulty"
    previousValue={props.currentValue}
    currentValue={props.previousValue}
    formatter={props.formatter}
  />
);

ContentCourseSpeechRateSummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
};

ContentCourseSpeechRateSummary.defaultProps = {
  isLoading: false,
};

export default ContentCourseSpeechRateSummary;
